<main class="wrapper">
    <app-terms-content></app-terms-content>
</main>
